import { faArrowUpArrowDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shared/components/ui/shadcn/select';
import React from 'react';

export type SortField = 'route' | 'location' | 'name' | 'quantity';
export type SortDirection = 'asc' | 'desc';

export interface SortConfig {
  field: SortField;
  direction: SortDirection;
}

interface ProductSortControlsProps {
  sortConfig: SortConfig;
  onSortChange: (config: SortConfig) => void;
}

type SortOption = {
  value: string;
  label: string;
  field: SortField;
  direction: SortDirection;
};

const SORT_OPTIONS: SortOption[] = [
  { value: 'route-asc', label: 'Ruta óptima', field: 'route', direction: 'asc' },
  { value: 'location-asc', label: 'Ubicación de A a Z', field: 'location', direction: 'asc' },
  { value: 'location-desc', label: 'Ubicación de Z a A', field: 'location', direction: 'desc' },
  { value: 'name-asc', label: 'Nombre de A a Z', field: 'name', direction: 'asc' },
  { value: 'name-desc', label: 'Nombre de Z a A', field: 'name', direction: 'desc' },
  { value: 'quantity-desc', label: 'Cantidad de mayor a menor', field: 'quantity', direction: 'desc' },
  { value: 'quantity-asc', label: 'Cantidad de menor a mayor', field: 'quantity', direction: 'asc' },
];

export const ProductSortControls: React.FC<ProductSortControlsProps> = ({ sortConfig, onSortChange }) => {
  // Construir el valor actual basado en el sortConfig
  const currentValue = `${sortConfig.field}-${sortConfig.direction}`;

  const handleSortChange = (value: string) => {
    const selectedOption = SORT_OPTIONS.find((option) => option.value === value);
    if (selectedOption) {
      onSortChange({
        field: selectedOption.field,
        direction: selectedOption.direction,
      });
    }
  };

  // Obtener la etiqueta del valor actual para mostrar en el trigger
  const currentLabel = SORT_OPTIONS.find((option) => option.value === currentValue)?.label || 'Seleccionar ordenación';

  return (
    <>
      {/* Versión móvil - Solo icono */}
      <div className="block lg:hidden">
        <Select value={currentValue} onValueChange={handleSortChange}>
          <SelectTrigger className="w-10 h-10 p-0 border-0 bg-transparent hover:bg-muted/50 transition-colors">
            <div className="flex items-center justify-center w-full h-full">
              <FontAwesomeIcon icon={faArrowUpArrowDown} className="w-4 h-4 text-muted-foreground" />
            </div>
          </SelectTrigger>
          <SelectContent>
            {SORT_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Versión desktop - Desplegable completo */}
      <div className="hidden lg:block">
        <Select value={currentValue} onValueChange={handleSortChange}>
          <SelectTrigger className="w-[220px]">
            <SelectValue placeholder="Seleccionar ordenación">{currentLabel}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {SORT_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
};
